// extracted by mini-css-extract-plugin
module.exports = {"indicator":"indicator-module--indicator--3W5Qa"};